<template>
  <div
    class="referrer-control"
    :class="{ disabled, 'dashboard': isDashboard }"
  >
    <ui-tabs
      class="referrer-tabs"
      :item-list="referrerTabs"
      :on="type"
      @select="$emit('type-change', $event)"
    />
    <div class="referrer-container">
      <div
        v-if="type === 'general'"
        class="refer-wrap"
        @mouseenter="$emit('refer-info-over')"
        @mouseleave="$emit('refer-info-out')"
      >
        <ui-selectbox
          :width="selectWidth"
          :dropWidth="dropWidth"
          :value="refer"
          :items="referrers"
          :disabled="disabled || referDisabled"
          @click="$emit('refer-info-out')"
          @input="$emit('refer-change', $event)"
        />

        <transition name="fade">
          <ui-tooltip
            class="refer-info"
            v-if="referPatternInfo"
            arrowTop
            arrowCenter
          >
            <span v-html="$t('journey.control.referPattern')"></span>
          </ui-tooltip>
        </transition>

        <ui-tooltip
          class="refer-info"
          v-if="referPatternUpdated"
          arrowTop
          arrowCenter
        >
          <span v-html="$t('journey.control.referPatternUpdated')"></span>
        </ui-tooltip>
      </div>
      <AiReferrerDropdown
        v-else
        :data="aiReferrerProviders"
        :selected-ai-referer-ids="selectedAiRefererIds"
        :disabled="disabled"
        @apply="$emit('ai-apply', $event)"
      />
    </div>
  </div>
</template>

<script>
import UiSelectbox from '@/components/ui/UiSelectbox'
import UiTabs from '@/components/ui/UiTabs.vue'
import UiTooltip from '@/components/ui/UiTooltip'
import AiReferrerDropdown from '@/components/report/AiReferrerDropdown.vue'

export default {
  name: 'ReferrerControl',
  components: {
    UiSelectbox,
    UiTabs,
    UiTooltip,
    AiReferrerDropdown
  },
  props: {
    type: {
      type: String,
      default: 'general'
    },
    refer: {
      type: [String, Number],
      default: null
    },
    referrers: {
      type: Array,
      default: () => []
    },
    aiReferrerProviders: {
      type: Array,
      default: () => []
    },
    selectedAiRefererIds: {
      type: Set,
      default: () => new Set()
    },
    disabled: {
      type: Boolean,
      default: false
    },
    referDisabled: {
      type: Boolean,
      default: false
    },
    referPatternInfo: {
      type: Boolean,
      default: false
    },
    referPatternUpdated: {
      type: Boolean,
      default: false
    },
    selectWidth: {
      type: Number,
      default: 142
    },
    dropWidth: {
      type: Number,
      default: 300
    },
    isDashboard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    referrerTabs () {
      return [
        {
          value: 'general',
          label: this.$t('common.referrer'),
          icon: 'icon--refer',
          iconHover: 'icon--refer hover',
          iconActive: 'icon--refer on',
          disabled: this.disabled
        },
        {
          value: 'ai',
          label: this.$t('common.aiReferrer'),
          icon: 'icon--peek',
          iconHover: 'icon--peek hover',
          iconActive: 'icon--peek on',
          disabled: this.disabled
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.referrer-control {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 18px;
  transition: transform 0.3s ease;

  &.disabled {
    pointer-events: none;
    opacity: 0.3;
  }

  &.dashboard {
    margin-left: 9px;
    margin-right: 8px;

    @media (max-width: 1440px) {
      /deep/ .ui-tabs button {
        min-width: 40px;
        padding: 9px 12px;

        .icon {
          left: 50%;
          transform: translateX(-50%);
        }

        .text {
          display: none;
        }

        &:last-child {
          &.on {
            &::before {
              left: -1px;
            }
          }
        }
      }
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    transform: translate(-100%, -50%);
    left: -12px;
    width: 1px;
    height: 16px;
    background-color: #e0e0e0;
  }
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translate(100%, -50%);
    right: -12px;
    width: 1px;
    height: 16px;
    background-color: #e0e0e0;
  }

  /deep/ .ui-tabs {
    background-color: #fff;
    button {
      min-height: 31px;
      padding: 9px 14px 9px 12px;
      .icon {
        top: 8px;
        left: 13px;
        width: 16px;
        height: 16px;
        background-size: contain;
      }
      .text {
        margin-left: 21px;
      }
      &.on {
        box-shadow: none;
      }

      &:last-child {
        margin-left: -7px;
        &.on {
          &::before {
            left: 1px;
            background-color: #0071e3;
          }
        }
      }
    }
  }

  @media (max-width: 1360px) {
    /deep/ .ui-tabs button {
      min-width: 48px;
      padding: 9px 16px;

      .icon {
        left: 50%;
        transform: translateX(-50%);
      }

      .text {
        display: none;
      }

      &:last-child {
        &.on {
          &::before {
            left: -1px;
          }
        }
      }
    }
  }

  .referrer-container {
  }

  div.refer-wrap {
    display: inline-block;
    position: relative;

    .refer-info {
      z-index: 99999;
      top: 43px;
      left: 50%;
      transform: translate(-50%, 0);
      padding: 20px;

      &.fade-enter-active,
      &.fade-leave-active {
        opacity: 1;
        transition: opacity 0.5s ease;
      }

      &.fade-enter,
      &.fade-leave-to {
        opacity: 0;
      }

      & /deep/ span {
        text-align: left;
        width: 258px;
        display: inline-block;
        word-break: break-word;
        white-space: break-spaces;

        a {
          color: #0074ff;
          font-size: 13px;
          line-height: 19px;
          vertical-align: middle;
          position: relative;
          display: inline-block;
          margin-top: 6px;

          i {
            position: relative;
            top: 3px;
            padding-right: 5px;
          }
        }
      }
    }
  }

  .ui_select {
    vertical-align: middle;

    & /deep/ {
      .label {
        display: none;
      }
      .item--wrap {
        height: 34px;
        padding-left: 8px;
        font-size: 13px;
        border: none;
        border-radius: 7px;
        box-shadow: inset 0 0 0 1px #e0e0e0;

        .selected-item {
          .name {
            max-width: 100% !important;
          }

          .additional {
            display: none;
          }

          .icon--drop-down {
            width: 14px;
            height: 14px;
            right: 9px;
          }
        }

        .item__list {
          top: -2px;

          .item__list-item {
            padding-left: 8px;
            height: 32px;
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
